var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"h5"},[_vm._t("heading")],2),_c('div',{staticClass:"card-sakali container"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }